// mm-price.js: self-healing prices for guide articles.
(function () {
  if (!/^\/blogs\//.test(location.pathname)) return;
  var spans = document.querySelectorAll('span.mm-price[data-handle]');
  if (!spans.length) return;
  var byHandle = {};
  spans.forEach(function (s) { (byHandle[s.dataset.handle] = byHandle[s.dataset.handle] || []).push(s); });
  function inr(paise) {
    var s = String(Math.round(paise / 100)), last3 = s.slice(-3), rest = s.slice(0, -3);
    return '₹' + (rest ? rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' : '') + last3;
  }
  Object.keys(byHandle).forEach(function (handle) {
    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants) return;
        var prices = p.variants.map(function (v) { return v.price; }).filter(function (x) { return x > 0; });
        if (!prices.length) return;
        var text = inr(Math.min.apply(null, prices));
        byHandle[handle].forEach(function (s) { s.textContent = text; });
      })
      .catch(function () {});
  });
})();
